import { getReportData } from "routes/sfg20-admin/plugins/system-info/reports-tab/controller/get-report-data"
import { Box, CircularProgress, Paper, Typography } from "@mui/material"
import { useState } from "react"
import { ReportByClient } from "routes/sfg20-admin/plugins/system-info/reports-tab/report-by-client"
import { Report } from "routes/sfg20-admin/plugins/system-info/reports-tab/report"
import { ReportSelector } from "routes/sfg20-admin/plugins/system-info/reports-tab/report-selector"
import { availableReports } from "routes/sfg20-admin/plugins/system-info/reports-tab/available-reports"

export function Reports() {
    let measure = "some-stat"
    const data = getReportData.useResults({ measure })
    const [report, setReport] = useState("ScheduleUsageCountByClient")

    if (!data) {
        return (
            <Paper elevation={3}>
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                    <CircularProgress />
                </Box>
                <Typography mt={4} variant="subtitle1" sx={{ width: "100%", textAlign: "center", marginBottom: 2 }}>
                    Fetching Data
                </Typography>
            </Paper>
        )
    }

    const stats = data?.results

    return (
        <>
            <ReportSelector setReport={setReport} />
            <Paper elevation={1}>
                {availableReports.map(({ id, component, columns, title }) => {
                    const componentsMap = {
                        Report,
                        ReportByClient,
                    }

                    const Component = componentsMap[component]

                    if (!Component || report !== id) return null

                    return (
                        <Component
                            title={title}
                            key={id}
                            data={stats[id]}
                            columns={columns.length ? columns : undefined}
                        />
                    )
                })}
            </Paper>
        </>
    )
}
